import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/hr/me/payslips')({
  component: MyPayslipsPage,
})

function MyPayslipsPage() {
  const { data, isLoading } = useQuery(orpc.hr.me.listOwnPayslips.queryOptions({ input: {} }))
  const rows = (data ?? []) as Array<{
    id: number
    periodStart: string
    periodEnd: string
    grossAmount: string | number | null
    netAmount: string | number | null
    status: string | null
  }>

  return (
    <Card>
      <CardContent className="p-0">
        {isLoading ? (
          <div className="p-6 text-muted-foreground">Loading...</div>
        ) : rows.length === 0 ? (
          <div className="p-6 text-muted-foreground">No payslips yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Period start</TableHead>
                <TableHead>Period end</TableHead>
                <TableHead>Gross</TableHead>
                <TableHead>Net</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{new Date(r.periodStart).toLocaleDateString()}</TableCell>
                  <TableCell>{new Date(r.periodEnd).toLocaleDateString()}</TableCell>
                  <TableCell>{r.grossAmount ?? '-'}</TableCell>
                  <TableCell>{r.netAmount ?? '-'}</TableCell>
                  <TableCell>{r.status ?? '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
